<template>
  <div :class="classes">
    <editorial-horizontal-immersive v-bind="model" :section-style="areaSectionStyle" :actpageFullUrl="common.actpageFullUrl">
      <slot></slot>
    </editorial-horizontal-immersive>
  </div>
</template>

<script>
import { mgnlComponentMixin } from "@wl-vue-mixins/mixins.js";
import Editorial              from "./Editorial";
import EditorialHorizontalImmersive from "./EditorialHorizontalImmersive.vue";

export default {
  mixins: [mgnlComponentMixin], // !!! all the mgnl components must be configured with mgnlComponentMixin !!!
  name: "MgnlEditorialImmersive",
  components: {
    Editorial,
    EditorialHorizontalImmersive
  },
  computed: {
    classes() {
      return this.areaModel ? `cell ${this.areaModel.cell}` : '';
    },
    areaSectionStyle() {
      return this.areaModel ? this.areaModel.sectionStyle : this.model.sectionStyle;
    }
  },
  props: ['areaModel']
};
</script>
